import React from 'react';
import { BsArrowLeft } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';
import { Button, Flex, Icon } from '@chakra-ui/react';
import PropTypes from 'prop-types';

function BackButton({ text,
  executable,
  dataAnalyticsId = undefined,
  url,
  onClick }) {
  const history = useHistory();

  const handleGoBack = async () => {
    await executable();

    if (url) {
      history.push(url);
    } else {
      history.goBack();
    }
  };

  const handleClick = onClick || handleGoBack;

  return (
    <Flex justify="flex-start" mb={5} w="100%">
      <Button
        data-analytics-id={dataAnalyticsId}
        dusk={dataAnalyticsId}
        fontSize="md"
        p={0}
        size="sm"
        textAlign="left"
        variant="textPrimary"
        onClick={handleClick}
      >
        <span>
          <Icon as={BsArrowLeft} boxSize="24px" mr={2} />
          {text}
        </span>
      </Button>
    </Flex>
  );
}

BackButton.propTypes = {
  text: PropTypes.string.isRequired,
  executable: PropTypes.func,
  dataAnalyticsId: PropTypes.string,
  url: PropTypes.string
};

export default BackButton;
